var _circle, _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAlertmodalinfo = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#EBF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 36.75C20.07 36.75 15.25 31.93 15.25 26C15.25 20.07 20.07 15.25 26 15.25C31.93 15.25 36.75 20.07 36.75 26C36.75 31.93 31.93 36.75 26 36.75ZM26 16.75C20.9 16.75 16.75 20.9 16.75 26C16.75 31.1 20.9 35.25 26 35.25C31.1 35.25 35.25 31.1 35.25 26C35.25 20.9 31.1 16.75 26 16.75Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.75C25.59 27.75 25.25 27.41 25.25 27V22C25.25 21.59 25.59 21.25 26 21.25C26.41 21.25 26.75 21.59 26.75 22V27C26.75 27.41 26.41 27.75 26 27.75Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30.9989C25.87 30.9989 25.74 30.9689 25.62 30.9189C25.5 30.8689 25.39 30.7989 25.29 30.7089C25.2 30.6089 25.13 30.5089 25.08 30.3789C25.03 30.2589 25 30.1289 25 29.9989C25 29.8689 25.03 29.7389 25.08 29.6189C25.13 29.4989 25.2 29.3889 25.29 29.2889C25.39 29.1989 25.5 29.1289 25.62 29.0789C25.86 28.9789 26.14 28.9789 26.38 29.0789C26.5 29.1289 26.61 29.1989 26.71 29.2889C26.8 29.3889 26.87 29.4989 26.92 29.6189C26.97 29.7389 27 29.8689 27 29.9989C27 30.1289 26.97 30.2589 26.92 30.3789C26.87 30.5089 26.8 30.6089 26.71 30.7089C26.61 30.7989 26.5 30.8689 26.38 30.9189C26.26 30.9689 26.13 30.9989 26 30.9989Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertmodalinfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alertmodalinfo.324a7f0b.svg";
export { ForwardRef as ReactComponent };